<template>
    <el-dialog title="修改角色信息" v-model="data.editVisible">
        <el-steps :active="activeStep" class="steps-container" finish-status="success" style="padding-bottom: 2rem;">
            <el-step v-for="(step, index) in steps" :key="index" :title="step.title" class="step-item" />
        </el-steps>
        <el-form v-if="activeStep == 0" v-model="editInfo">
            <el-form-item label="上传图片">
                <el-upload action="https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15"
                    accept=".jpeg,.png,.jpg" list-type="picture-card" :on-preview="handlePreview"
                    :on-remove="handleRemove" :auto-upload="false" :on-change="handleFileChange"
                    :file-list="data.currentImage" :limit="1">
                    <el-icon>
                        <Plus />
                    </el-icon>
                </el-upload>
            </el-form-item>
            <el-form-item label="id">
                <el-input v-model="editInfo.id" />
            </el-form-item>
            <el-form-item label="世界">
                <el-input v-model="editInfo.world" />
            </el-form-item>
            <el-form-item label="姓名">
                <el-input v-model="editInfo.name" />
            </el-form-item>
            <el-form-item label="描述">
                <el-input v-model="editInfo.nameComment" />
            </el-form-item>
            <el-form-item label="别名">
                <el-input v-model="editInfo.anotherName" />
            </el-form-item>
            <el-form-item label="性别">
                <el-input v-model="editInfo.sex" />
            </el-form-item>
            <el-form-item label="年龄">
                <el-input v-model="editInfo.age" />
            </el-form-item>
            <el-form-item label="身高">
                <el-input v-model="editInfo.height" />
            </el-form-item>
            <el-form-item label="特征">
                <el-input v-model="editInfo.appearance" />
            </el-form-item>
            <el-form-item label="身份">
                <el-input v-model="editInfo.tag" />
            </el-form-item>
            <el-form-item label="阵营">
                <el-input v-model="editInfo.camp" />
            </el-form-item>
            <el-form-item label="喜欢">
                <el-input v-model="editInfo.favor" />
            </el-form-item>
            <el-form-item label="讨厌">
                <el-input v-model="editInfo.unfavor" />
            </el-form-item>
            <el-form-item label="印象">
                <el-input v-model="editInfo.impression" />
            </el-form-item>
            <div class="step-btn-group">
                <el-button type="primary" @click="activeStep = 1">下一步</el-button>
                <el-button type="primary" @click="submit" :loading="data.loading">保存</el-button>
                <el-button @click="cancel">取消</el-button>
            </div>
        </el-form>

        <el-form v-if="activeStep == 1" v-model="editInfo">
            <el-form-item label="关系">
                <el-input v-model="editInfo.relation" :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" />
            </el-form-item>
            <el-form-item label="评价">
                <el-input v-model="editInfo.relationComment" :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" />
            </el-form-item>
            <el-form-item label="更多">
                <el-input v-model="editInfo.moreRelationComment" :autosize="{ minRows: 1, maxRows: 10 }"
                    type="textarea" />
            </el-form-item>
            <el-form-item label="能力">
                <el-input v-model="editInfo.superpower" :autosize="{ minRows: 1, maxRows: 10 }" type="textarea" />
            </el-form-item>
            <el-form-item label="评价">
                <el-input v-model="editInfo.superpowerComment" :autosize="{ minRows: 1, maxRows: 10 }"
                    type="textarea" />
            </el-form-item>
            <el-form-item label="副作用">
                <el-input v-model="editInfo.superpowerSideEffect" :autosize="{ minRows: 1, maxRows: 10 }"
                    type="textarea" />
            </el-form-item>
            <div class="step-btn-group">
                <el-button type="default" @click="activeStep = 0"> 上一步 </el-button>
                <el-button type=" primary" @click="activeStep = 2">下一步</el-button>
                <el-button type="primary" @click="submit" :loading="data.loading">保存</el-button>
                <el-button @click="cancel">取消</el-button>
            </div>
        </el-form>

        <el-form v-if="activeStep == 2" v-model="editInfo">
            <el-form-item label="初识">
                <el-input v-model="editInfo.storyStranger" :autosize="{ minRows: 1, maxRows: 20 }" type="textarea" />
            </el-form-item>
            <el-form-item label="友好">
                <el-input v-model="editInfo.storyAcquaintance" :autosize="{ minRows: 1, maxRows: 20 }"
                    type="textarea" />
            </el-form-item>
            <el-form-item label="亲近">
                <el-input v-model="editInfo.storyFriend" :autosize="{ minRows: 1, maxRows: 20 }" type="textarea" />
            </el-form-item>
            <div class="step-btn-group">
                <el-button type="default" @click="activeStep = 1"> 上一步 </el-button>
                <el-button type=" primary" @click="activeStep = 3">下一步</el-button>
                <el-button type="primary" @click="submit" :loading="data.loading">保存</el-button>
                <el-button @click="cancel">取消</el-button>
            </div>
        </el-form>
        <el-form v-if="activeStep == 3" v-model="editInfo">
            <el-form-item label="秘密">
                <el-input v-model="editInfo.storySecret" :autosize="{ minRows: 1, maxRows: 20 }" type="textarea" />
            </el-form-item>
            <el-form-item label="内核">
                <el-input v-model="editInfo.storyEssence" :autosize="{ minRows: 1, maxRows: 20 }" type="textarea" />
            </el-form-item>
            <el-form-item label="轶事">
                <el-input v-model="editInfo.storyEpisode" :autosize="{ minRows: 1, maxRows: 20 }" type="textarea" />
            </el-form-item>
            <el-form-item label="事件">
                <el-input v-model="editInfo.storyEvent" :autosize="{ minRows: 1, maxRows: 20 }" type="textarea" />
            </el-form-item>
            <el-form-item label="时间线">
                <el-input v-model="editInfo.timeline" :autosize="{ minRows: 1, maxRows: 20 }" type="textarea" />
            </el-form-item>
            <div class="step-btn-group">
                <el-button type="default" @click="activeStep = 2"> 上一步 </el-button>
                <el-button type="primary" @click="submit" :loading="data.loading">保存</el-button>
                <el-button @click="cancel">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
    <el-dialog title="新增角色信息" v-model="data.createVisible">
        <el-form :model="editInfo" :inline="true">
            <el-form-item label="上传图片">
                <el-upload action="https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15"
                    accept=".jpeg,.png,.jpg" list-type="picture-card" :on-preview="handlePreview"
                    :on-remove="handleRemove" :auto-upload="false" :on-change="handleFileChange"
                    :file-list="data.currentImage" :limit="1">
                    <el-icon>
                        <Plus />
                    </el-icon>
                </el-upload>
            </el-form-item>
            <el-form-item label="id">
                <el-input v-model="editInfo.id" />
            </el-form-item>
            <el-form-item label="世界">
                <el-input v-model="editInfo.world" />
            </el-form-item>
            <el-form-item label="姓名">
                <el-input v-model="editInfo.name" />
            </el-form-item>
            <el-form-item label="性别">
                <el-input v-model="editInfo.sex" />
            </el-form-item>
            <el-form-item label="年龄">
                <el-input v-model="editInfo.age" />
            </el-form-item>
            <el-form-item label="身高">
                <el-input v-model="editInfo.height" />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" :loading="data.loading">保存</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <el-dialog title="删除角色信息" v-model="data.deleteVisible">
        <el-form :model="editInfo" :inline="true">
            <el-form-item>
                是否删除“{{ editInfo.name }}”相关的角色信息？
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" :loading="data.loading">确认</el-button>
                <el-button @click="cancel">取消</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
    <el-button type="primary" @click="handleCreate">新增</el-button>
    <!-- <div>
        <el-checkbox v-model="data.checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">
            展示全部
        </el-checkbox>
        <el-checkbox-group v-model="data.checkedProperties" @change="handleCheckedPropertiesChange">
            <el-checkbox v-for="item in data.allProperties" :key="item.prop" :label="item.prop">
                {{ item.label }}
            </el-checkbox>
        </el-checkbox-group>
    </div> -->
    <div>
        <el-table :data="charaList.charaInfo" stripe border>
            <el-table-column show-overflow-tooltip prop="id" label="编号" />
            <el-table-column show-overflow-tooltip label="图片预览">
                <template #default="scope">
                    <el-image style="width: 100%" :src="'http://img.helloworldend.top/upload/' + scope.row.img"
                        show-progress fit="cover" />
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="name" label="姓名" />
            <el-table-column show-overflow-tooltip prop="sex" label="性别" />
            <el-table-column show-overflow-tooltip prop="age" label="年龄" />
            <el-table-column show-overflow-tooltip prop="height" label="身高" />
            <el-table-column show-overflow-tooltip prop="status" label="状态" />
            <el-table-column show-overflow-tooltip prop="updateTime" label="更新时间" />
            <el-table-column label="操作" fixed="right" width="250">
                <template #default="scope">
                    <el-button type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="default" @click="handleEnable(scope.$index, scope.row)">{{ scope.row.status ===
                        0 ? "启用" : "禁用" }}</el-button>
                    <el-button type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div>
        <el-pagination v-if="charaList" layout="prev, pager, next" :current-page="data.currentPage"
            :size="data.pagesize" :total="charaList.total" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
    </div>
</template>
<script setup>
import { ref, reactive, watch, nextTick, onMounted } from 'vue';
import { defineEmits } from 'vue';
import { Plus } from '@element-plus/icons-vue'

import service from '@/utils/request.js'


const editInfo = ref({
    name: null,
    sex: null,
    age: null,
    height: null,
    status: 1,
    updateTime: null
})
const originInfo = ref()

const charaList = ref({})

const props = defineProps({
    employee: {
        type: Object,
        default: {}
    },
    parentCurrentPage: {
        type: Number
    },
    charaNameList: {
        type: Object
    },
})

const data = ref({
    submit_button_disabled: false,
    loading: false,
    currentPage: 1,
    pagesize: 10,
    editVisible: ref(false),
    createVisible: ref(false),
    deleteVisible: ref(false),
    currentImageVisible: ref(false),
    currentImage: ref([]),
    uploadFile: ref(),
    checkAll: ref(false),
    checkedProperties: ref(["name", "sex", "age", "height", "status", "updateTime"]),
    allProperties: ref([
        { prop: 'name', label: '姓名' },
        { prop: 'sex', label: '性别' },
        { prop: 'age', label: '年龄' },
        { prop: 'height', label: '身高' },
        { prop: 'appearance', label: '特征' },
        { prop: 'camp', label: '阵营' },
        { prop: 'like', label: '喜欢' },
        { prop: 'dislike', label: '讨厌' },
        { prop: 'tag', label: '标签' },
        { prop: 'impression', label: '印象' },
        { prop: 'relation', label: '关系' },
        { prop: 'status', label: '状态' },
        { prop: 'updateTime', label: '更新时间' }])
});


const steps = ref([
    { title: '简介' },
    { title: '能力' },
    { title: '故事1' },
    { title: '故事2' }
]);
const activeStep = ref(0);

const handlePreview = () => {
    data.value.currentImageVisible = true
}

const handleRemove = () => {
    data.value.uploadFile = null;
    $('.el-upload').css('display', 'flex');
}

const handleFileChange = (file, newFileList) => {
    data.value.currentImage = newFileList;
    data.value.uploadFile = file.raw;
    if (data.value.currentImage.length > 0) {
        $('.el-upload').css('display', 'none');
    }
};



const handleEdit = (id, row) => {
    editInfo.value = JSON.parse(JSON.stringify(row));
    originInfo.value = JSON.parse(JSON.stringify(row));
    data.value.editVisible = true;
}

const handleDelete = (id, row) => {
    editInfo.value = JSON.parse(JSON.stringify(row));
    data.value.deleteVisible = true;
}

const handleCreate = () => {
    data.value.createVisible = true;
    resetEditInfo();
}

const cancel = () => {
    data.value.editVisible = false;
    data.value.createVisible = false;
    data.value.deleteVisible = false;
}

const submit = async () => {
    if (data.value.editVisible) {
        if (JSON.stringify(editInfo.value) === JSON.stringify(originInfo.value)) {
            data.value.editVisible = false;
        }
        try {
            // 表格校验
            data.loading = true;
            if (data.value.uploadFile) {
                const formData = new FormData();
                formData.append('file', data.value.uploadFile);
                try {
                    const uploadRes = await service.post("/admin/common/upload", formData);
                    if (uploadRes.data != false) {
                        editInfo.value.img = uploadRes.data;
                    }
                }
                catch (error) {
                    console.log(error);
                }
            }
            try {
                const uploadPropertyRes = await service.put("/admin/chara", editInfo.value);
                if (uploadPropertyRes.data != false) {
                    data.loading = false;
                } else {
                    data.loading = false;
                    console.log(error);
                }
            } catch (error) {
                console.log(error);
            }
            data.value.editVisible = false;
            handleRefresh(data.value.currentPage, data.value.pagesize);
        } catch (error) {
            console.log(error);
        }
    } else if (data.value.createVisible) {
        if (data.value.uploadFile) {
            const formData = new FormData();
            formData.append('file', data.value.uploadFile);
            try {
                const uploadRes = await service.post("/admin/common/upload", formData);
                if (uploadRes.data != false) {
                    editInfo.value.image = uploadRes.data;
                }
            }
            catch (error) {
                console.log(error);
            }
        }
        try {
            // 表格校验
            data.loading = true;
            editInfo.value.updateTime = new Date();
            const res = await service.post("/admin/chara", editInfo.value)
            if (res.data != false) {
                handleRefresh(data.value.currentPage, data.value.pagesize);
                data.loading = false;
            } else {
                data.loading = false;
                console.log(error);
            }
            data.value.createVisible = false;
        } catch (error) {
            console.log(error);
        }
    } else if (data.value.deleteVisible) {
        try {
            // 表格校验
            data.loading = true;
            const res = await service.delete("/admin/chara", {
                params: {
                    id: editInfo.value.id
                }
            })
            if (res.data != false) {
                handleRefresh(data.value.currentPage, data.value.pagesize);
                data.loading = false;
            } else {
                data.loading = false;
                console.log(error);
            }
            data.value.deleteVisible = false;
        } catch (error) {
            console.log(error);
        }
    }

}

const handleEnable = async (id, row) => {
    try {
        const status = row.status === 1 ? 0 : 1;
        const url = `/admin/chara/status/${status}`;
        const res = await service.post(url, null, {
            params: {
                id: row.id
            }
        });
        if (res.data != false) {
            handleRefresh(data.value.currentPage, data.value.pagesize);
        } else {
            console.log(error);
        }
    } catch (error) {
        console.log(error);
    }
}

const handleCurrentChange = (val) => {
    data.value.currentPage = val;
    handleRefresh(data.value.currentPage, data.value.pagesize);
}

const handleSizeChange = (val) => {
    return
}

const resetEditInfo = () => {
    editInfo.value = {
        name: null,
        sex: null,
        age: null,
        height: null,
        status: 1,
        updateTime: null
    };
}

const getCharaList = (currentPage, pagesize) => {
    const params = {
        page: currentPage,
        pageSize: pagesize,
        name: null
    };
    service.get("/admin/chara/page", { params })
        .then(res => {
            const total = res.data.total;
            const rst = res.data.records;
            if (rst.length != 0 && rst[0] != null) {
                let colName = Object.keys(rst[0]);
                const mapping = {
                    'name': '姓名',
                    'id': 'id',
                    'world': '世界观',
                    'nameComment': '姓名注解',
                    'anotherName': '别名',
                    'img': '头像',
                    'sex': '性别',
                    'age': '年龄',
                    'height': '身高',
                    'status': '状态',
                };

                // 使用map方法根据映射关系替换元素
                let colLabel = colName.map(item => mapping[item] || item);
                charaList.value = { charaInfo: rst, colName: colName, colLabel: colLabel, total: total };
            } else {
                console.error('返回角色信息为空', error);
            }
        }).catch(error => {
            console.error('获取角色信息失败', error);
        });
}

const handleRefresh = (currentPage, pagesize, id) => {
    getCharaList(currentPage, pagesize, id);
};

onMounted(() => {
    getCharaList(props.parentCurrentPage, data.value.pagesize, null);
})


</script>
<style scoped></style>